<template>
  <div class="modal-content fm-modal-upload">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ $t('filemanager.modal.share.title') }}: {{ selectedItem.basename }}
      </h5>
      <button type="button" class="close" aria-label="Close" v-on:click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="col-12">
        <label>{{ $t("pages.users.title") }} </label>
        <multiselect v-model="userList" label="firstname" :custom-label="fullName" :options="users" :multiple="true"
          tage-placeholder="" placeholder="" track-by="id" :taggable="true" @input="onChange($event)" @tag="addTag">
        </multiselect>
      </div>
      <div class="row">
        <div class="col-md-12 pb-4">
          <div class="q-pa-md">
            <div v-if="isLoading" class="mt-2">
              <b-skeleton-table :rows="6" :columns="4"></b-skeleton-table>
            </div>
            <table class="table table-hover mt-2" v-else-if="userList.length > 0">
              <thead class="thead-light">
                <tr>
                  <th class="text-left">COLLABORATEURS</th>
                  <th class="text-center">
                    {{ $t("filemanager.modal.properties.access_rights.read_only") }}
                  </th>
                  <th class="text-center">
                    {{ $t("filemanager.modal.properties.access_rights.read_and_write") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(_user, index) in userList" :key="index" class="table-row">
                  <td>{{ _user.user ? _user.user.firstname + " " + _user.user.lastname : _user.firstname + " " +
                  _user.lastname }}</td>
                  <td class="text-center">
                    <input type="radio" :name="_user.user ? _user.user.id : _user.id" @change="
                      updatePermission(_user.user ? _user.user.id : _user.id, 1)
                    " :checked="(_user.access && _user.access === 1) ? 1 : 0" />
                  </td>
                  <td class="text-center">
                    <input type="radio" :name="_user.user ? _user.user.id : _user.id" @change="
                      updatePermission(_user.user ? _user.user.id : _user.id, 2)
                    " :checked="(_user.access && _user.access === 2) ? 1 : 0" />
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center empty-state-container mt-4" v-else>
              <div class="row">
                <div class="col-md-3 mx-auto">
                  <lottie-animation ref="anim" :animationData="require('@/assets/json/empty-state.json')"
                    :loop="true" />
                </div>
              </div>
              <h4 class="text-center">{{ $t("pages.users.inactiveUser") }}</h4>
              <p class="mt-2">{{ $t("pages.users.userData") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn" v-bind:class="[users ? 'btn-primary' : 'btn-light']" v-bind:disabled="!users"
        v-on:click="share">
        {{ $t('filemanager.btn.submit') }}
      </button>
      <button class="btn btn-light" v-on:click="hideModal()">
        {{ $t('filemanager.btn.cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import modal from "../mixins/modal";
import helper from "../../../router/mixins/helper";
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";

export default {
  name: "Share",
  mixins: [modal, helper],
  components: {
    Multiselect,
    LottieAnimation
  },
  data() {
    return {
      users: [],
      isLoading: false,
      userList: []
    };
  },
  computed: {
    ...mapState({
      recipients: (state) => state.users
    }),
    /**
     * Selected item
     * @returns {*}
     */
    selectedItem() {
      return this.$store.getters[`${this.activeManager}/selectedList`][0];
    },


    // userList: function () {
    //   return this.$store.state.users;
    // },

    // userList: {
    //   get() {
    //     return this.$store.state.users
    //   },
    //   set(value) {
    //     console.log('value', value);
    //     if (value.length) {
    //       const userId = this.userList.find((user) => user.id === value[0].id)
    //       if (userId) this.$store.commit("setShareList", this.userList);
    //       else this.$store.commit("shareList", value);
    //     } 


    //     // console.log("Value : ", value);
    //     // this.$store.state.users = this.$store.state.users.filter(item => item.id != value[0].id);
    //     // this.$store.commit("shareList", this.userList);
    //     // const selected = [];
    //     // if (value) {
    //     //   this.administrators.forEach((administrator) => {
    //     //     selected.push(administrator.id);
    //     //   });
    //     // }
    //     // this.selectedAdmins = selected;
    //   },
    // },
  },
  methods: {
    ...mapActions(["getUsers", "sendNotif"]),

    addTag(newTag) {
      const tag = {
        label: newTag,
        type: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.user.push(tag);
      this.users.push(tag);

      console.log(this.user);
    },

    updatePermission(user, access) {
      let selectedUser = this.userList.filter(
        (item) => item.id === user
      );
      selectedUser[0].access = access;

      console.log("Selected User : ", this.userList);
      this.$store.commit("shareList", this.userList);
    },

    fullName ({ firstname, lastname }) {
      return `${firstname}  ${lastname}`
    },

    onChange(event) {
      if (event.length) {
        const userId = this.userList.find((user) => user.id === event[0].id)
        if (userId) this.$store.commit("setShareList", this.userList);
        else this.$store.commit("shareList", event);
      }

      this.$store.commit("shareList", this.userList);
      // let id = (this.selectedItem && this.selectedItem.type === 'dir') ? 
      //             this.selectedItem.folder_id : this.selectedItem.doc_id;
      // let type = this.selectedItem.type;
      // this.$store.dispatch("shareList", { id, type }).then(response => {
      //   console.log("SON : ", response.data.data);
      //   this.$store.commit('shareList', response.data.data);
      // })
    },

    share() {
      let id = (this.selectedItem && this.selectedItem.type === 'dir') ? 
                this.selectedItem.folder_id : this.selectedItem.doc_id;
      let data = {
        id: id,
        path: this.selectedItem.path,
        type: this.selectedItem.type,
        users: this.userList
      }

      if(this.userList.length !== 0) {
        this.userList.forEach(user => {
          this.notifyUser(user.id);
        })
      }

      this.$store.dispatch("share", { data }).then(() => {
        this.hideModal();
      }).catch(() => {
        this.hideModal();
      });
    },
    notifyUser(id) {
    let notifier = JSON.parse(localStorage.getItem('user'));
    let notif = {
      user_id : id,
      title: notifier.name,
      content: 'Vous a partagé des documents',
      mentions: this.mentionedItems
    };
    this.sendNotif(notif);
  }
  },
  created() {
    let id = (this.selectedItem && this.selectedItem.type === 'dir') ? 
                  this.selectedItem.folder_id : this.selectedItem.doc_id;
    let type = this.selectedItem.type;
    this.$store.dispatch("shareList", { id, type }).then((response) => {
      this.userList = response.data.data.map((e) => {
        const user = {
          id: e.user.id,
          shareId: e.id,
          recipient: e.recipient,
          firstname: e.user.firstname,
          lastname: e.user.lastname,
          access: e.access,
        };
        return user;  
      });
      this.$store.dispatch("getAllUsers").then((response) => {
          console.log(response);
        if (response.status == 200) {
          this.isLoading = false;
          this.users = response.data;
        } else {
          this.isLoading = false;
        }
      })
      .catch(() => {
        this.isLoading = false;
      });

    }).catch(() => {
    
    });
    
  },
};
</script>

<style lang="scss">
.fm-modal-upload {
  .fm-btn-wrapper {
    position: relative;
    overflow: hidden;
    padding-bottom: 6px;
    margin-bottom: 0.6rem;
  }

  .fm-btn-wrapper input[type="file"] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }

  .fm-upload-list .far {
    padding-right: 0.5rem;
  }

  .fm-upload-list .form-check-inline {
    margin-right: 0;
  }

  .fm-upload-info>.progress {
    margin-bottom: 1rem;
  }
}
</style>
